/**
 * Habits Tab — layout container.
 * Mobile: vertical stack, view mode switch (monthly/weekly).
 * Desktop: always monthly grid.
 */

import React from 'react'
import { useHomeStore } from '@turnifly/shared/stores'
import { HabitBanner } from './habit-banner'
import { DailyQuote } from './daily-quote'
import { FeedbackCard } from './feedback-card'
import { StatsRow } from './stats-row'
import { HabitTrackerGrid } from './habit-tracker-grid'
import { HabitWeeklyView } from './habit-weekly-view'
import { CategoryStatsCard } from './charts/category-stats-card'
import { TaskBoardList } from './task-board-list'

export const HabitsTab: React.FC = () => {
  const viewMode = useHomeStore((s) => s.viewMode)

  return (
    <div className="flex flex-col gap-2.5 w-full pb-24 lg:pb-8">
      <HabitBanner />
      <DailyQuote />

      <div className="flex flex-col lg:flex-row gap-2.5">
        <div className="lg:flex-1 lg:min-w-0">
          <FeedbackCard />
        </div>
        <div className="lg:w-auto lg:shrink-0">
          <StatsRow />
        </div>
      </div>

      {/* Monthly grid — always on desktop, on mobile only when viewMode=monthly */}
      {/* Weekly view — mobile only when viewMode=weekly */}
      {viewMode === 'weekly' ? (
        <div className="lg:hidden">
          <HabitWeeklyView />
        </div>
      ) : null}
      <div className={viewMode === 'weekly' ? 'hidden lg:block' : ''}>
        <HabitTrackerGrid />
      </div>

      <CategoryStatsCard />
      <TaskBoardList />
    </div>
  )
}
